export type Settings = {
  openaiApiKey?: string;
  model: string;
  globalPrompt: string;
  insightsPrompt: string;
};

const DEFAULT_GLOBAL_PROMPT = `You are in charge of asking running surveys and aggregate the respondent answers.
When submitted a survery, you will ask specifically 1000 people representative of the "demographicTarget".
Make sure you all the questions as answered.
Only create a TextSummary for questions of type text.
For questions of type text, don't create a histogram.
For questions of type number, create a histogram with 10 bins.
`;

const DEFAULT_INSIGHTS_PROMPT = `You are an analyst in charge of summarizing the survey finding.
Based on the goals stated in the survey and your domain expertise (related to the domain of the questions)
- summarize insights, clarify the findings that the survey tend to prove but point the limitations and warn against some specific responses that could be interpreted in very different ways. Focus on non-obvious arguments that could be actionnable.
- suggest some follow up questions to improve the conclusions of the survey, formulate them as if you were directly asking respondents. Don't add follow up questions if you don't have solid reasons to believe key insights will be uncovered.
- if possible make some practical recommendations for actions motivated by this survey
- write a concise conclusion on the learnings and limits of the survey

Don't bullshit, be very concise and to the point, omit sentences that may be true but either obvious or too general.
Don't provide more than 4 points per list unless it's actually really interesting, feel free to only add one item if there is not much actually interesting insights to explain.
As an expert talking to experts, you are allowed to use advanced industry jargon to make more concise and insightful remarks.
`;

const AVAILABLE_MODELS = ["gpt-4o-2024-08-06"];

export const DEFAULTS_SETTINGS: Settings = {
  openaiApiKey: "",
  model: AVAILABLE_MODELS[0],
  globalPrompt: DEFAULT_GLOBAL_PROMPT,
  insightsPrompt: DEFAULT_INSIGHTS_PROMPT,
};

export function getSettings(): Settings {
  const settingsStr = localStorage.getItem("settings");
  if (!settingsStr) {
    return DEFAULTS_SETTINGS;
  }
  const s = JSON.parse(settingsStr);
  s.model = s.model || DEFAULTS_SETTINGS.model;
  s.globalPrompt = s.globalPrompt || DEFAULTS_SETTINGS.globalPrompt;
  s.insightsPrompt = s.insightsPrompt || DEFAULTS_SETTINGS.insightsPrompt;
  return s;
}
